export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/45b3d9bead8ca49501a2a3b80e7cc1ac.png";